import "./ParichayaPage.css";
import Footer from "../../components/Footer/Footer";

function ParichayaPage() {
  return (
    <div>
      <div className="parichaya-page">
        <div className="parichaya-page__content">
          <b>दार्चुला जिल्ला को परिचय </b> <br></br>
          <br></br>
          नेपालको सुदूरपश्चिमाञ्चल विकास क्षेत्र अन्तरगत महाकाली अञ्चलका ४
          जिल्ला मध्ये छुट्टै महत्व रहेको योजिल्ला एशियाका दुई शक्तिशालीराष्ट्र
          भारत र चीनको सिमाना संग जोडिएको दार्चुला जिल्लाको नाम दार्चुला कसरी
          रहनगयो भन्ने सम्बन्धमा कुनै लिखित प्रमाण प्राप्त नभएतापनि विभिन्न
          किबंदन्तिहरु सुन्नपाईन्छन्। दार्चुला शव्द उच्चारणगर्दा दारचूला भएपनि
          स्थानीय भाषाको दुईवटा शव्द धाररचूलावाट विकसित भएको हो । स्थानीय भाषामा
          धारको अर्थ पहाडको अग्लो चुचुरो र चुलाको अर्थ चुल्हो हुन्छ । यस भेगमा
          खानपकाउन प्रयोगगरीने चुल्हो हरुप्रायःएकसमानका तिनवटा ढुङ्गाहरुमा
          माटोपोतेर चुचुरोको आकारमा वनेका हुन्छन् । यसरी तिनै तिर चुचुरो (धार)
          जस्तो चुल्हो वनाई खानपकाउनेठाउँ भएकोले धारचुला नाम रहेको र धारचुलापछि
          अपभ्रम्स भई दारचुला र त्यसपछि दार्चुला वन्नगएकोहो भन्ने एकथरिको
          भनाईरहेकोछ।
          <br></br>
          <br></br>
          <div className="parichaya-page__image-box">
            <div>
              अर्कोकिम्वदन्ति अनुसार यहाँ स्थित तिनवटापहाडका चुचुरा हरु
              वर्तमानमा एक पहाड भारत र दुईवटा पहाड नेपालमै रहेकाछन्।फेदी वाट
              हेर्दा धारपरेकोजस्तो स्थानीयचुल्होको आकारमा
              चुचुरोदेखिन्छ।प्राचिनकालमा व्याँस हिमालवाट व्याँसऋषि तपस्यागरी
              फर्कदा यीतिनधारहरुको चुल्हो बनाई भातपकाई खाएकोहुनाले योठाउँको नाम
              धारचूला रहनगएको र धारचूला शव्दअ पभ्रम्स भई दार्चुला रहेकोहोभन्ने
              अर्को भनाईरहेको छ।दार्चुला जिल्लाको सिमाना चीनको तिव्वत क्षेत्रसित
              जोडिएको छ।तिव्वत संग व्यापारगर्ने यहाँको प्रमुख नाकाको रुपमा
              व्याँसक्षेत्ररहेको छ।व्याँसवाट तिव्वतक्षेत्रमा आवतजावत गर्दा एउटा
              भन्ज्याङपारगरी जानुपर्ने हुन्छ।जसलाई तिव्वतिभाषामा“ला” भनिन्छ।यो
              भन्ज्याङ तिव्वतसिंत व्यापारगर्ने द्वार (बाटो) भएकोले द्वारर“ला”
              शब्दहरु मिलि दार्चुला नाम रहनगएकोहो भन्ने पनि अर्को भनाई पाईन्छ।
            </div>
            <div id="parichaya-page__image-box__para-2">
              यस जिल्लाको पूर्वमा वझाङ्ग जिल्ला, पश्चिममा भारतको उत्तराखण्ड
              प्रदेशको पिथौरागढ, उत्तरमा चीनको स्वशासित क्षेत्र तिब्बत र
              दक्षिणमा बैतडी जिल्ला रहेकाछन्। विश्व मान चित्रमा २९डिग्री ३६मिनेट
              उत्तर देखि३० डिग्री १५ मिनेट उत्तरी अक्षांशर ८०डिग्री २२मिनेट
              पूर्व देखि ८१डिग्री ०९मिनेट पूर्वीदेशान्तर सम्म फैलिएको छ।यस
              जिल्लाको कुलक्षेत्रफल २३२२वर्ग कि.मी. छ।समुद्री सतह बाट ५१८मी.
              देखि ७१३२मी. सम्म उचाई रहेकोछ।बार्षिक औषत बर्ष २१२९मी.मी. रहेको
              त्यस्तै औषततापक्रममा न्यूनतम ५.७०से. अधिकतम २८.६० से.रहेको पाईन्छ
              यस जिल्लाको अग्लो अपीहिमाल, लिपुलेक आदि जिल्लाको आकर्षणको
              केन्द्ररहेका छन्।यस्तै चीनको तिब्बत क्षेत्रमा अवस्थित हिन्दूहरुको
              महत्वपूर्ण तीर्थस्थल तथा पर्यटकीय महत्व समेत बोकेको मानसरोवर जाने
              प्रमुख मार्गको रुपमासमेत दार्चुला जिल्ला रहेको छ।यसजिल्लाको
              सदरमुकाम खलंगा महाकालीनदीको किनारमा भारतको धारचुलासंग जोडिई
              अवस्थितरहेको छ।
              <br></br>
              <br></br>
            </div>
            <div id="parichaya-page__image-box__para-3">
              स्थानीयतह पुर्न संरचना अनुसार दार्चुला जिल्ला १ (एक) संघीयसंसदीय
              क्षेत्र, २ (दुई) वटा प्रदेश संसदीय क्षेत्र,२ (दुई) वटा नगरपालीका
              (वडासंख्या १८) ७ (सात) वटा गाउँपालिका (वडासंख्या ४३) गरीजम्मा ६१
              टा वडाहरु सहित ९ (नौ) वटा स्थानीयतहमा विभाजित छ। व्यास गाउँपालीका
              भारत र चीनसंग सीमाना जोडिएकोछ त्यस्तै दुहुँ गाउँपालिका, महाकाली
              नगरपालीका, मालिकार्जुन गाउँपालिका र लेकम गाउँपालिका भारत संग
              सीमाना जोडिएको छ।
            </div>

            <div id="parichaya-page__image-box__para-4">
              २०७८ सालको राष्ट्रिय जनगणना अनुसार दार्चुला जिल्लाको कुल जनसंख्या
              १३२,२२६रहेको छ।जस मध्ये पुरुषको संख्या ६३३७४ रहेकोछ भने महिलाको
              संख्या ६८८५२ रहेकोछ, दार्चुला जिल्लामा कुलघरधुरी संख्या २८३८१
              रहेकोछ साथै दार्चुलाको औसतघरधुरी आकार ४.६६र जनघनत्व ५७ प्रतिवर्ग
              किमी रहेकोछ भने जिल्लाको बार्षिक जनसंख्या बृद्धि दर०.८८% रहेकोमा
              लै‌गिक अनुपात९१.३रहेको छ।
            </div>
            <div id="parichaya-page__image-box__para-5">
              स्थानीयतह पुर्न संरचना अनुसार दार्चुला जिल्ला १ (एक) संघीयसंसदीय
              क्षेत्र, २ (दुई) वटा प्रदेश संसदीय क्षेत्र,२ (दुई) वटा नगरपालीका
              (वडासंख्या १८) ७ (सात) वटा गाउँपालिका (वडासंख्या ४३) गरीजम्मा ६१
              टा वडाहरु सहित ९ (नौ) वटा स्थानीयतहमा विभाजित छ। व्यास गाउँपालीका
              भारत र चीनसंग सीमाना जोडिएकोछ त्यस्तै दुहुँ गाउँपालिका, महाकाली
              नगरपालीका, मालिकार्जुन गाउँपालिका र लेकम गाउँपालिका भारत संग
              सीमाना जोडिएको छ।
            </div>
            <img
              src="assets/images/darchula.png"
              alt="Map of Darchula District"
            />
          </div>
          दार्चुला जिल्‍ला नेपालको सुदुरपश्‍चिम अवस्‍थित एयटा जिल्‍ला हो ।
          दार्चुला नेपालको पश्‍चिम तिरको अन्‍तिम जिल्‍ला हो । सुदुरपश्‍चिम
          प्रदेश अन्‍तर्गत दार्चुला जिल्‍लाको सदरमुकाम खलंगा बरपरका क्षेत्रहरु
          छापरी काटैँ धाप दत्तु गरि ९ वटा वडाहरुमा बिभाजन महाकाली नगरपालिका
          स्‍वावलम्‍बी सहकारीको कार्य क्षेत्र भित्र पर्दछ। सहकारीको कार्य
          क्षेत्र भित्र उच्च हिमाली क्षेत्र देखी नदी किनारामा रहेका फाँटहरु तथा
          अनुपम नमुनाको रुपमा जैविक बिधितता तथा प्राकृतिक सम्‍पदाले भरिपूर्ण र
          विविध जातजाति भाषाभाषी धर्मावलम्‍बीहरुको साझाँ बसोबास रहेको पाईन्‍छ ।
          <br></br>
          <br></br>
          अन्तराष्ट्रिय सहकारीका मुल्य मान्यता र सिद्धान्त अनुसार सदस्यहरुलाई
          आफुले आर्जनगरेको आयबाट नियमितरुपले बचतगर्ने बानी बसाल्न उत्प्रेरित गरी
          संकलनभएको बचतरकमबाट आवश्यक भएका सदस्यहरुलाई सीपमूलक, आय आर्जन लगायत
          आर्थिक संकट टार्न आवश्यकपर्ने क्षेत्रमा उचित व्याजदरमा ऋणलगानी गरी
          सदस्यहरुको आर्थिक,सामाजिक अवस्थामा सुधार गर्नुका साथै विभिन्न भौतिक
          पुर्वाधार निर्माण गर्ने तथा बचत ऋण सम्बन्धी कृयाकलापका माद्यमबाट
          महाकाली नगरपालिकाको विभिन्नस्थानमा स्‍वावलम्‍बन, स्‍वउतरदायित्‍व,
          लोकतन्‍त्र, समानता, समता, ऐक्‍यबद्‍ता, ईमान्‍दारीता, खुलापनर सामाजिक
          उतरदायित्‍व लगायतका मूल्‍यमान्यता सहित कार्यक्रमहरु संचालन गर्ने
          उद्देश्यले सहकारीता क्षेत्रका सरोकारवलाहरुको २०६८।०१।१९ को भेला
          बाटमहाकाली नगरपालिका वडा नं. ५ मा स्वाबलम्बी बचत तथा ऋण सहकारी संस्था
          लिमिटेडको नामले स्‍थापना गरिएको स्‍वायत्त सहकारी संस्‍था हो ।<br></br>
          <br></br>
          <br></br>
          स्थायी लेखा नं ६१८९३३०७१ साविकको डभिजन सहकारी कार्यालय मा दर्ता नम्बर
          ३८३/०६७/०६८मिति२०६८।०१।१९ मा विधिवत दर्ता भई तपसिलको उद्देश्य र कार्य
          सहित महाकाली नगरपालिकाको नियामक क्षेत्र भित्र प्रचलित कानुन बमोजिम
          संचालनमा रहेको रहकारी संस्था हो ।<br></br>
          <br></br>
          <br></br>
          क) उद्देश्य <br></br> १. संस्थामा संलग्न सदस्यहरुमा मितव्ययिताको भावना
          जागएत गराई नियमित बचत गर्ने बानीको विकास गर्ने।
          <br></br>
          २. सदस्यहरुको व्यक्तिगत एवं सामुहिक क्षमता अभिबृद्धि गरी स्वावलम्बी
          एवं आत्मनिर्भर समाजको निर्माणमा योगदान पुय्याउने।
          <br></br>
          ३. सदस्यहरुको प्राथमिक आवश्यकता र आय आर्जन क्षमताको पहिचान गरी
          उत्पादनशील र आयमुलक क्षेत्रमा सदस्यहरु मार्फत लगानी प्रवर्द्धन गरी
          छरिएर रहेको राष्ट्रिय पूँजीको उपयोग बडाउने ।<br></br>
          ४. सदस्यहरुको दैनिक जीवनका विविध क्षेत्रमा संस्थागत सहयोग पुयाउने
          खालका सेवामुलक कार्यक्रमहरु संचालन गरी सहकारीताको महत्व स्थापित हुने
          काम समुदायमा प्रर्दशित गर्ने।
          <br></br>
          <br></br>
          <br></br>
          ख) कार्यहरुः
          <br></br>
          १. सदस्यहरुबाट स्वीकृत नीति अनुसार बचत संकलन गर्ने।
          <br></br> २. सदस्यहरुबाट स्वीकृत नीति अनुसार ऋण लगानी गर्ने।<br></br>{" "}
          ३. सहकारी ऐन, नियमावली र विनियमको अधीनमा रही अन्य संघ-संस्थाबाट ऋण
          लिने। <br></br>४. सहरकीता बारे सदस्यहरुको चेतना जगाउने क्रियाकलाप
          संचालन गर्ने। <br></br> ५. सदस्यहरुलाई सीपमुलक तालिमको अवसर प्रदान गरी
          व्यवसायीक सीप अभिवृद्धि गर्ने। <br></br> ६. शिक्षा, स्वास्थ्य, आवास,
          यातायात, कृषि, उद्योग, व्यापार लगायतका विभिन्न क्षेत्रमा कार्यक्रम
          तयगरी तत् सम्बन्धी काममा सदस्यहरुलाई व्यक्तिगत वा सामुहिक रुपमा ऋण
          प्रवाह गर्ने। <br></br>७. सदस्यहरुलाई दैनिक जीवनमा आवश्यक पर्ने विविध
          कामहरुमा न्युनतम सेवा शुल्क लिइ वा नलिई सेवा पुय्याउने काम नगर्ने।{" "}
          <br></br> ८. सदस्यहरुलाई सूचना प्रवाह गरी व्यावसायीक ज्ञान र अवसारमा
          पहुँच बढाउने काम गर्ने। <br></br> ९. आफ्ना सदस्यहरुलाई साना तिन
          जोखिमबाट ऋण दिन सदस्यहरुको सामुहिक सहयोग उपलब्ध गराउने संस्थागत
          प्रबन्ध गर्ने। <br></br> १०. कारोवारको मुनाफाबाट केही अंश छूट्याई
          सदस्यहरु एवं तिनका परिवारका सदस्यहरुलाई रचनात्मक कार्यम उत्प्रेरित
          गर्ने खालका कार्यक्रम संचालन गर्ने। <br></br>११. विनियममा व्यवस्था
          भएका विविध कोषहरुको प्रभावकारी ढंगले उपयोग गर्ने। माथी उल्लेखित कार्य
          गर्न प्रचलित कानुन बमोझिम अन्य कुनै निकायबाट स्वीकृति लिनु पर्ने वा
          सम्झौता गर्नु पर्ने भएमा सो गरी नियामक निकायको कार्यालयलाई जानकारी
          गराए पछि मात्र कार्य संचालन गरिनेछ।
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default ParichayaPage;
